var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 88,
    viewBox: "0 0 91 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9371 19.8301H16.2823V35.7607L0.351562 35.7607L0.351563 49.4156H16.2823V65.3462H29.9371V49.4156H45.8678V35.7607L29.9371 35.7607V19.8301Z",
    fill: "#F6FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4493 0.410156H64.7588V11.7158H53.4531V21.4063H64.7588V32.7119H74.4493V21.4063H85.755V11.7158H74.4493V0.410156ZM66.4424 13.3994H55.1367V23.0899H66.4424V34.3956H76.1329V23.0899H87.4386V13.3994H76.1329V2.09377H66.4424V13.3994ZM67.0493 2.70065V14.0063H55.7436L55.7436 22.483H67.0493V33.7887H75.5261V22.483H86.8317V14.0063H75.5261V2.70065H67.0493Z",
    fill: "#A6C6F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4821 67.0629L89.3177 56.2274L98.1149 65.0246L87.2793 75.8601L86.8502 76.2892L87.2793 76.7184L98.1149 87.5539L89.3177 96.3511L78.4821 85.5156L78.053 85.0864L77.6238 85.5156L66.7883 96.3511L57.9911 87.5539L68.8266 76.7184L69.2558 76.2892L68.8266 75.8601L57.9911 65.0246L66.7883 56.2274L77.6238 67.0629L78.053 67.4921L78.4821 67.0629Z",
    stroke: "#A6C6F9",
    strokeWidth: 1.21377
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateRightIcon);
export default __webpack_public_path__ + "static/media/create-right-icon.7efc539763de6de08197c56cd74f86b2.svg";
export { ForwardRef as ReactComponent };